var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon20PxLikeOutline(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.65377 8.86426H6.16015V15.5371H3.65377C3.51353 15.5371 3.37904 15.4815 3.27987 15.3822C3.18071 15.2831 3.125 15.1486 3.125 15.0084V9.39301C3.125 9.25278 3.18071 9.11829 3.27987 9.01913C3.37904 8.91997 3.51353 8.86426 3.65377 8.86426Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1582 8.86391L8.84436 4.57044C8.94846 4.40074 9.09474 4.26089 9.26895 4.16452C9.44316 4.06815 9.63937 4.01856 9.83845 4.02054C9.99525 4.01488 10.1516 4.04071 10.2982 4.0965C10.4449 4.15229 10.5788 4.2369 10.6922 4.34535C10.8056 4.4538 10.8961 4.58386 10.9583 4.72788C11.0206 4.87188 11.0533 5.02691 11.0546 5.18379V8.26113H15.6973C15.8688 8.26669 16.0372 8.3085 16.1914 8.38382C16.3457 8.45913 16.4822 8.56622 16.5921 8.69807C16.702 8.82993 16.7827 8.98354 16.829 9.14882C16.8753 9.3141 16.886 9.48731 16.8605 9.65703L16.0145 15.1138C15.9785 15.4054 15.837 15.6738 15.617 15.8686C15.397 16.0633 15.1133 16.171 14.8194 16.1713H7.88199C7.55175 16.1726 7.22579 16.0966 6.93021 15.9491L6.16878 15.5685",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1582 8.86401V15.5369",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon20PxLikeOutline);
export default __webpack_public_path__ + "static/media/icon_20px_like_outline.a0931270b94d8dc973a1b9b4f9dc67e8.svg";
export { ForwardRef as ReactComponent };